import { PaymentMethodProps } from "./types";
import {
  StyledPaymentMethod
} from "./style";

function PaymentMethod({
  buttonText,
  paymentMethods,
  checkoutWithCard,
  currency,
  buttonColor,
  className
}: PaymentMethodProps) {
  
  const checkoutWithCardHandler = () => {
    checkoutWithCard(currency);
  }

  return (
    <StyledPaymentMethod
      className={className}
      colorOne={buttonColor.colorOne}
      colorTwo={buttonColor.colorTwo || buttonColor.colorOne}
      gradientDirection={buttonColor.gradientDirection}
    >
      <button onClick={checkoutWithCardHandler}><span>{buttonText}</span></button>
      <div className='paymendMethods'>
        {
          paymentMethods.map((paymentMethod, i) => <img key={i} alt="payment method" src={paymentMethod} />)
        }
      </div>
    </StyledPaymentMethod>
  );
}

export default PaymentMethod;
